<template>
  <div>
    <in-wrapper>
      <in-ibox>
        <div slot="title">
          Contacts
          <router-link :to="`/admin/billing/contacts/new`" class="btn btn-primary btn-xs pull-right"><i class="fa fa-plus"></i> New Contact</router-link>
        </div>
        <div slot="content" class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-2">
                <label for="">Status</label>
                <v-select options="" v-model="filters.status" multiple="multiple" @input="loadInvoices"></v-select>
              </div>
              <div class="col-lg-2">
                <label for="">Clients</label>
                <v-select options="" label="name" index="id" v-model="filters.clients" @input="loadInvoices" multiple="multiple"></v-select>
              </div>
              <div class="col-lg-2">
                <label for="">Department</label>
                <v-select options="" label="Name" index="TrackingOptionID" v-model="filters.departments" @input="loadInvoices" multiple="multiple"></v-select>
              </div>
              <div class="col-lg-2">
                <label for="">Account</label>
                <v-select options="" label="Name" index="AccountID" v-model="filters.account" @input="loadInvoices" multiple="multiple"></v-select>
              </div>
              <div class="col-lg-2"></div>
            </div>
            <table class="table table-striped table-hover m-t-sm">
              <thead>
              <tr>
                <th>Date</th>
                <th>Number</th>
                <th>Client</th>
                <th>Ref</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
              </thead>
              <tbody>
              </tbody>
            </table>
          </div>
        </div>
      </in-ibox>
    </in-wrapper>
  </div>
</template>
<script>
export default {
  data () {
    return {
      filters: {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Billing/Contacts.vue